import React, { Component, useState } from "react";
import { Link } from "react-router-dom";

import Cookies from "universal-cookie"
import PropTypes from "prop-types"
import {setLanguage, translate} from 'react-switch-lang'; 
import { slide as Menu } from 'react-burger-menu'

import BurgerMenu from "./BurgerMenu";

import "../styles/Header.css"


class Header extends Component{

    constructor(props){
        super(props);
        const cookieLanguage = new Cookies('language');
        const lang = cookieLanguage.get('language');
        setLanguage(lang);        
    }

    icons(){
      if(this.props.showIcons==true)
        return <div className="headerButtons">
                <Link to="/My-Portfolio">
                  <i className="fa fa-home botonHome" aria-hidden="true" id="headerButtonId"></i>
                </Link>
                <Link to={this.props.urlBack} className="aFlecha">
                  <i className="fa fa-arrow-left botonFlechaIzq" aria-hidden="true" id="headerButtonId"></i>
                </Link>
            </div>
      
      return <div className="oculto"></div>
    }


    render(){

        const {t} = this.props;

        return(
            <div className="Header">

                {this.icons()}
                
                <div className="Titulo">
                  <h1 className="tituloPrimero">{t('headerTitle.first')} </h1>
                  <h1 className="tituloSegundo"> {t('headerTitle.second')} </h1>
                </div>

                <BurgerMenu/>
                    
            </div>
        )
    }
}

Header.propTypes = {
    t: PropTypes.func.isRequired,
  };
  
  export default translate(Header);